/** Highest commission an admin may set: 30 % = 3000 basis points. */
export const MAX_COMMISSION_BPS = 3000

/**
 * "7,5" / "7.5" / " 12 " -> basis points (750 / 750 / 1200). Returns null for
 * anything that is not a number between 0 and 30 with at most 2 decimals.
 */
export function parseCommissionPercent(input: string): number | null {
  const normalized = input.trim().replace(',', '.')
  if (!/^\d{1,2}(\.\d{1,2})?$/.test(normalized)) return null
  const bps = Math.round(Number(normalized) * 100)
  return bps >= 0 && bps <= MAX_COMMISSION_BPS ? bps : null
}

/** 750 -> "7,5" ; 0 -> "0" ; 1250 -> "12,5" (the input field text, comma decimal). */
export function commissionBpsToInput(bps: number): string {
  return String(bps / 100).replace('.', ',')
}
